





























































//import Vue from 'vue';
import {Component, Vue} from "vue-property-decorator";
import AlbumComp from "./components/AlbumComp.vue";
import NavBarComp from "./components/NavBarComp.vue";
import FullScreenRequire from "./components/FullScreenRequire.vue";
import RotateLock from "./components/RotateLock.vue";
import Footer from "./components/Footer.vue";
import screenfull from "screenfull";


@Component({
    components:{
        FullScreenRequire,
        RotateLock,
        AlbumComp,
        Footer,
        NavBarComp
    }
})
  export default class App extends Vue {

    private jsonData: CatalogInfo = catalogInfo;

    public get themeClass():string {
        return this.jsonData.theme == 'dark' ? 'dark-mode' : 'light-mode';
    }

    public get rtlClass():string{
        return this.jsonData.isRTL ? 'fs-rtl' : '';
    }

    public get isRTL() :boolean {
        return this.jsonData.isRTL;
    }


    public requestFullScreen() {
        if (screenfull && screenfull.isEnabled) {
            screenfull.request();
        }else{
            var ele = document.getElementById('bottom-anchor');
            if(ele) {
                ele.scrollIntoView();
            }
        }

    }

    private mounted(){
    }
}
